"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _constants = require("../constants");
var _staticContent = require("../staticContent");
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../utils");
var _validate = _interopRequireDefault(require("./DatePickerFieldUtils/validate"));
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DatePickerField = props => {
  var {
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    hint,
    tooltip,
    isRequired = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    clickedSubmit = false,
    label = _staticContent.DATEPICKER_FIELD.DEFAULT_LABEL,
    value,
    initialVisibleMonth,
    onChange = () => {},
    fieldName,
    inputRef,
    isReadOnly = false,
    customErrorMessage,
    offset = 1,
    variant = _staticContent.DATEPICKER_FIELD.DEFAULT_VARIANT,
    datePickerType = _staticContent.DATEPICKER_FIELD.DATEPICKER_TYPE[0],
    dateSlots = []
  } = props;
  // pass default value - for preFillValue
  // format should be YYYY/MM/DD as per canadian gov standard
  var [dateValue, setDateValue] = (0, _react.useState)(value && (_moment.default.isMoment(value) || (0, _moment.default)(value, 'YYYY/MM/DD', true).isValid()) ? (0, _moment.default)(value) : undefined);
  var [validationStatus, setValidationStatus] = (0, _react.useState)(undefined);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  (0, _react.useEffect)(() => {
    if (dateValue === undefined && !clickedSubmit) {
      return;
    }
    var isValid = (0, _validate.default)(isRequired, dateValue, offset, datePickerType, dateSlots);
    setValidationStatus(isValid ? 'success' : 'error');
    if (isValid) {
      setDateValue(dateValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRequired, value, clickedSubmit, dateValue, offset]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        var isValid = (0, _validate.default)(isRequired, dateValue, offset, datePickerType, dateSlots);
        setValidationStatus(isValid ? 'success' : 'error');
      }
    }
  }, [dateValue, buttonControlPressed, currentStepReferences, inputRef, isRequired, offset, datePickerType, dateSlots]);
  (0, _react.useEffect)(() => {
    if (value === undefined) {
      return;
    }
    onChange(value, (0, _validate.default)(isRequired, value, offset, datePickerType, dateSlots));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, isRequired, value, offset]);
  var onFieldChange = value => {
    var formattedValue = _moment.default.isMoment(value) ? (0, _moment.default)(value).format('YYYY/MM/DD') : undefined;
    setDateValue(value);
    var isValid = (0, _validate.default)(isRequired, value, offset, datePickerType, dateSlots);
    onChange(formattedValue, isValid);
    setValidationStatus(isValid ? 'success' : 'error');
  };
  var optionalProps = {};
  if (initialVisibleMonth) {
    optionalProps.initialVisibleMonth = initialVisibleMonth;
  }
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.DatePicker, _extends({
    ref: inputRef,
    disabled: isReadOnly,
    name: "DatePickerField_".concat(fieldName),
    id: String(Date.now()),
    hint: hint,
    tooltip: tooltip,
    hintPosition: hintPosition,
    copy: language,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    onDateChange: onFieldChange,
    date: dateValue,
    validation: validationStatus,
    required: isRequired,
    placeholder: _staticContent.DATEPICKER_FIELD.PLACEHOLDER[language],
    isDayDisabled: date => {
      if (datePickerType === _staticContent.DATEPICKER_FIELD.DATEPICKER_TYPE[1]) {
        var formattedDateToCheck = (0, _moment.default)(date).startOf('day').format('YYYY-MM-DD');
        var formattedDatesArray = dateSlots.map(date => (0, _moment.default)(date).startOf('day').format('YYYY-MM-DD'));
        return !formattedDatesArray.includes(formattedDateToCheck);
      } else {
        var currentDate = (0, _moment.default)();
        var daysDifference = date.diff(currentDate.startOf('day'), 'days', true);
        return daysDifference >= offset ? false : true;
      }
    },
    feedback: validationStatus === 'error' ? customErrorMessage || _staticContent.DATEPICKER_FIELD.FORMAT_ERROR[language] : undefined,
    inline: variant === _staticContent.DATEPICKER_FIELD.VARIANTS[1],
    "data-testid": "DatePickerField-testid"
  }, optionalProps)));
};
DatePickerField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  tooltip: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  preFillValue: _propTypes.default.object,
  clickedSubmit: _propTypes.default.bool,
  value: _propTypes.default.string,
  /*
   * initialVisibleMonth is a string in the format 'YYYY/MM'
   * It is used to set the initial month displayed in the date picker.
   * If not provided, the date picker will default to the current month.
   */
  initialVisibleMonth: _propTypes.default.string,
  isReadOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  offset: _propTypes.default.number,
  variant: _propTypes.default.oneOf(['Regular', 'Inline']),
  datePickerType: _propTypes.default.oneOf(['Normal', 'Genesys']),
  dataSlots: _propTypes.default.array
};
var _default = exports.default = DatePickerField;